import React from 'react';
import AdherenceDetailsPanel from './AdherenceDetailsPanel';
import IssuesDetailsPanel from './IssuesDetailsPanel';
import CSATDetailsPanel from './CSATDetailsPanel';
import DWSDetailsPanel from './DWSDetailsPanel';
import VitalsDetailsPanel from './VitalsDetailsPanel';
import NoSelectionCard from '../../../../../Dashboard/detailPanel/NoSelectionCard ';

interface DetailsPanelProps {
  selectedCard: string | null;
  ownerId?: number; // Optional, if needed for specific panels
}

const DetailsPanel: React.FC<DetailsPanelProps> = ({
  selectedCard,
  ownerId,
}) => {
  if (!selectedCard) {
    return <NoSelectionCard />;
  }
  switch (selectedCard) {
    case 'adherence':
      return <AdherenceDetailsPanel customerId={ownerId || 0} />;
    case 'issues':
      return <IssuesDetailsPanel customerId={ownerId || 0} />;
    case 'csat':
      return <CSATDetailsPanel customerId={ownerId || 0} />;
    case 'dws':
      return <DWSDetailsPanel customerId={ownerId || 0} />;
    case 'vitals':
      return <VitalsDetailsPanel />;
    default:
      return null;
  }
};

export default DetailsPanel;
